import { render } from "./TestsCard.vue?vue&type=template&id=c3278680&scoped=true"
import script from "./TestsCard.vue?vue&type=script&lang=js"
export * from "./TestsCard.vue?vue&type=script&lang=js"

import "./TestsCard.vue?vue&type=style&index=0&id=c3278680&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3278680"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QAvatar,QBtn,QInnerLoading});
